import { setGlobalMessage } from 'containers/MessageHandler/actions';
import { api } from 'redux/api/index.api';
import { quality as qualityEnum } from 'utils/constants';
import { downloadFile, getFilename } from 'utils/file';

export const mediaServiceApi = api.injectEndpoints({
  endpoints: builder => ({
    download: builder.query({
      query: ({ url, mediaId, quality }) => ({
        method: 'GET',
        url: `${url || `medias/${mediaId}`}/download`,
        params: { quality },
        responseHandler: response => response.blob(),
      }),
      async onQueryStarted({ fileName, mimeType }, { dispatch, queryFulfilled }) {
        try {
          dispatch(
            setGlobalMessage({
              type: 'success',
              intlMessage: {
                id: 'download_in_progress',
              },
              active: true,
            }),
          );
          const { data } = await queryFulfilled;
          if (data) {
            const blob = data instanceof Blob ? data : new Blob(data);
            const fakeUrl = window.URL.createObjectURL(blob);
            downloadFile(fakeUrl, getFilename(fileName, mimeType));
          }
        } catch (error) {
          console.error('Error downloading media:', error);
        }
      },
    }),
    getImageUrl: builder.query({
      async queryFn({ url, quality = qualityEnum.original }, _queryApi, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `${url}/url`,
          params: { quality },
        });

        if (result.data?.media_url && (result.data?.width || quality === qualityEnum.original)) {
          return { data: result.data.media_url };
        }

        const fallback = await baseQuery({
          url: `${url}/url`,
          params: { quality: qualityEnum.thumbnail },
        });

        if (fallback.error) return fallback;
        if (fallback.data?.media_url) {
          return { data: fallback.data.media_url };
        }

        return { data: null };
      },
      keepUnusedDataFor: 300,
    }),
  }),
  overrideExisting: 'throw',
});

export const { useLazyDownloadQuery, useGetImageUrlQuery } = mediaServiceApi;
